<template>
    <section>
        <b-alert :show="successMessageShow" dismissible variant="success">
            Message Sent. We appreciate you for reaching out and will reply soon.
        </b-alert>
        <div class="row">

            <div id="content" class="col-sm-12">
                <div class="material-box bg-white">
                    <div class="row content-row">
                        <div class="col-md-12 top-title">
                            <h3>Contact Us </h3>
                        </div>
                        <div class="col-md-12">
                            <div class="p-b-10">

                                <div class="row">
                                    <!-- begin col-6 -->
                                    <div class="col-md-12">
                                        <div class="contentWrap" style="border: none;">
                                            <div class="contentbox">
                                                <div class="section-content contact-form">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <b-alert :show="errShow" dismissible>
                                                                {{ response }}
                                                            </b-alert>
                                                        </div>
                                                        <div class="col-md-12 mb-2">
                                                            <h2>Message Us!</h2>
                                                        </div>
                                                        <div class="row" style="width: 100%; margin: 0 !important;">
                                                            <div class="col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <label for="FirstName">First Name (*)</label>
                                                                    <b-form-input type="text" id="FirstName"
                                                                        name="FirstName" autocomplete="FirstName"
                                                                        placeholder=" Enter First Name"
                                                                        v-model="userData.FirstName"
                                                                        aria-describedby="firsterr"
                                                                        :state="$v.userData.FirstName.$dirty ? !$v.userData.FirstName.$error : null"></b-form-input>
                                                                    <b-form-invalid-feedback id="firsterr">
                                                                        This is a required field.
                                                                    </b-form-invalid-feedback>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <label for="LastName">Last Name (*)</label>
                                                                    <b-form-input type="text" id="LastName"
                                                                        name="LastName" autocomplete="LastName"
                                                                        placeholder=" Enter Last Name"
                                                                        v-model="userData.LastName"
                                                                        aria-describedby="lasterr"
                                                                        :state="$v.userData.LastName.$dirty ? !$v.userData.LastName.$error : null"></b-form-input>
                                                                    <b-form-invalid-feedback id="lasterr">
                                                                        This is a required field.
                                                                    </b-form-invalid-feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row" style="width: 100%; margin: 0 !important;">
                                                            <div class="col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <label for="Email">Email Address (*)</label>
                                                                    <b-form-input type="email" id="Email" name="Email"
                                                                        autocomplete="Email"
                                                                        placeholder=" Enter Email Address"
                                                                        v-model="userData.email"
                                                                        aria-describedby="emailerr"
                                                                        :state="$v.userData.email.$dirty ? !$v.userData.email.$error : null"></b-form-input>
                                                                    <b-form-invalid-feedback id="emailerr">
                                                                        This is a required field.
                                                                    </b-form-invalid-feedback>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <label for="phone">Phone No.</label>
                                                                    <b-form-input type="text" id="phone" name="phone"
                                                                        autocomplete="phone"
                                                                        placeholder=" Enter Phone Number"
                                                                        v-model="userData.phone"
                                                                        aria-describedby="phoneerr"
                                                                        :state="$v.userData.phone.$dirty ? !$v.userData.phone.$error : null">
                                                                    </b-form-input>
                                                                    <b-form-invalid-feedback id="phoneerr">
                                                                        This is a required field.
                                                                    </b-form-invalid-feedback>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label for="description"> Message</label>
                                                                <textarea class="form-control" rows="5"
                                                                    v-model="userData.message" name="messsage"
                                                                    placeholder="Enter Your Message"
                                                                    style="min-height: 100px;max-height: 100px;"></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div>
                                                                <button @click="sendEmail"
                                                                    class="btn btn-primary mb-2 btn-blue submit"><i
                                                                        class="fa fa-paper-plane"
                                                                        aria-hidden="true"></i>
                                                                    Send Message</button>
                                                            </div>
                                                            <div style="margin: 20px;">
                                                                <p><b>DC Trainings</b></p>
                                                                <p>700 River Street</p>
                                                                <p>Santa Cruz, CA 95060</p>
                                                                <p>831-889-8033</p>
                                                                <a
                                                                    href="https://dctrainings.com/">WWW.DCTrainings.com</a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                        </div>
                                                        <div class="col-md-6">
                                                            <!-- <div class="material-list video" v-if="daysDiff > 7">
                                                                <img src="https://dctrainings.com/gts/resources/assets/img/Schedule_A_Meeting.png" alt="Image Description" class="image-class" style="height: 200px; float: inline-end;">  

                                                                <a href="#" @click="openCalendly">
                                                                    <li class="uncomplete btn btn-primary btn-blue w-100 color-white">
                                                                        <span>
                                                                            Training Questions?? Schedule a coaching call with Dr. Sawyer
                                                                        </span>
                                                                    </li>
                                                                </a>
                                                            </div>

                                                            <div class="material-list video" v-if="daysDiff > 7">
                                                                <img src="https://dctrainings.com/gts/resources/assets/img/Schedule_A_Meeting.png" alt="Image Description" class="image-class" style="height: 200px; float: inline-end;">  
                                                                <a href="#" @click="openCalendly">
                                                                    <li class="uncomplete btn btn-primary btn-blue w-100 color-white">
                                                                        <span>
                                                                            Training Questions?? Schedule a coaching call with Dr. Sawyer
                                                                        </span>
                                                                    </li>
                                                                </a>
                                                            </div>

                                                             <div class="material-list video" v-else>
                                                                <img src="https://dctrainings.com/gts/resources/assets/img/Schedule_A_Meeting.png" alt="Image Description" class="image-class" style="height: 200px; float: inline-end;">  
                                                                <a href="#" @click="openCalendly">
                                                                <li class="uncomplete btn btn-primary btn-blue w-100 color-white">
                                                                    <span>Training Questions? Schedule a coaching call with Dr. Sawyer</span>
                                                                    </li>
                                                               </a>
                                                            </div> -->
                                                        </div>

                                                    </div>
                                                </div>
                                                <!-- <div class="box-detail" style="margin-left: 0;">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <p><b>DC Trainings</b></p>
                                                            <p>700 River Street</p>
                                                            <p>Santa Cruz, CA 95060</p>
                                                            <p>831-889-8033</p>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <br><br>
                                                <div class="section-content box-detail" style="margin-left: 0;">
                                                    <iframe
                                                        src="https://mapsengine.google.com/map/embed?mid=zNXX1_b9q8pQ.kX9pFP7XjtoA"
                                                        width="100%" height="480"></iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end row -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- end page-header -->
            </div>
        </div>
    </section>
</template>

<script>

import userAPI from "./userApi";
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";

export default {
    name: "contact_us",
    mixins: [validationMixin],
    data() {
        return {
            successMessageShow: false,
            userData: {
                FirstName: "",
                LastName: "",
                phone: "",
                email: "",
                message: ''
            },
            response: '',
            errShow: false,
            userID: '',
            daysDiff: '',
        }
    },
    validations: {
        userData: {
            FirstName: {
                required,
            },
            email: {
                required, email
            },
            LastName: {
                required,
            },
            phone: {
                required,
            },
        }
    },
    methods: {
        sendEmail() {
            this.errShow = false;
            this.$v.userData.$touch()
            if (this.$v.userData.$anyError) {
                return;
            }
            userAPI.sendEmail(this.userData, res => {
                this.errShow = true;
                this.response = res.data.message;
                this.successMessageShow = true;
                this.userData = {
                    FirstName: "",
                    LastName: "",
                    phone: "",
                    email: "",
                    message: '',
                };
                this.$v.$reset();
            }, err => {
                console.log(err);
            })
        },
        getCurrentUserID() {
            userAPI.getCurrentUserID(res => {
                this.userID = res.data.data.UserID;
            }, err => {
                console.log(err);
            });
        },
        getCalendlyEvent() {
            userAPI.getCalendlyEvent(res => {
                this.daysDiff = res.data.data;
                console.log(this.daysDiff);
                // this.userID = res.data.data.UserID;
            }, err => {
                console.log(err);
            });
        },
        openCalendly() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/15min?utm_source=' + this.userID + '&utm_medium=contact_us_page'
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        }
    },
    mounted() {
        this.getCurrentUserID();
        this.getCalendlyEvent();
    },
}
</script>

<style>
li.uncomplete.btn.btn-primary.btn-blue {
    white-space: pre-wrap;
    text-align: center;
}

@media (max-width: 550px) {
    .contact-form h2 {
        font-size: 24px;
    }
}
</style>